import {
  QuestionnaireResponseBack,
  QuestionnaireResponseFront,
  QuestionnaireResponseDataBack,
  QuestionnaireResponseFromBack,
} from './types';

export const quizFromBack = (input: QuestionnaireResponseFromBack): QuestionnaireResponseFromBack => ({
  ...input,
});

export const quizsFromBack = (input: QuestionnaireResponseDataBack): QuestionnaireResponseDataBack => ({
  ...input,
});

/*
export const quizsFromBack = (
  input: QuestionnaireResponseDataBack,
): Map<string, Array<QuestionnaireResponseFromBack>> => {
  const groupedResponses = new Map<string, Array<QuestionnaireResponseFromBack>>();

  input.items.forEach(item => {
    const { questionnaireKey } = item;

    if (!groupedResponses.has(questionnaireKey)) {
      groupedResponses.set(questionnaireKey, []);
    }
    const responses = groupedResponses.get(questionnaireKey);
    if (responses) {
      responses.push(item);
    }
  });

  return groupedResponses;
};
*/

export const questionnaireResponseToBack = (input: QuestionnaireResponseFront): QuestionnaireResponseBack => ({
  ...input,
  data: {
    ...input.data,
    ...input.data.alert,
    timestamps: {
      ...input.data.timestamps,
      started: input.data.timestamps.started?.toISOString() || '',
      finished: input.data.timestamps.finished?.toISOString() || '',
    },
    questions: input.data.questions.map(question => ({
      ...question,
      responses_raw: question.responses_raw.filter(response => response !== ''),
      responses_keyed: question.responses_keyed.filter(response => response !== ''),
    })),
  },
});
